import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

type Props = { title: ReactNode; action?: ReactNode; className?: string; children: ReactNode }

export function SidePanelSection({ title, action, className, children }: Props) {
  return (
    <section className={cn('space-y-2', className)}>
      <div className="flex min-h-5 items-center justify-between gap-2">
        <h4 className="truncate text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">{title}</h4>
        {action}
      </div>
      {children}
    </section>
  )
}
